/**
 * @generated SignedSource<<5f48b7f016b18dcfebbb36e895e033dd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SectionPage_page$data = {
  readonly breadcrumbs: ReadonlyArray<{
    readonly " $fragmentSpreads": FragmentRefs<"Breadcrumb_data">;
  } | null | undefined> | null | undefined;
  readonly sections: ReadonlyArray<{
    readonly __typename: string;
    readonly anchorName: string;
    readonly navigationTitle: string | null | undefined;
    readonly titleImageBackgroundUrl: string;
    readonly titleImageUrl: string;
    readonly " $fragmentSpreads": FragmentRefs<"HomeFundInfoserviceSection_pageSection" | "HomeFundIntroductionSection_pageSection" | "HomeFundServiceSection_pageSection" | "LinkSection_pageSection" | "OverviewSection_pageSection">;
  }>;
  readonly " $fragmentType": "SectionPage_page";
};
export type SectionPage_page$key = {
  readonly " $data"?: SectionPage_page$data;
  readonly " $fragmentSpreads": FragmentRefs<"SectionPage_page">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SectionPage_page",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Breadcrumb",
      "kind": "LinkedField",
      "name": "breadcrumbs",
      "plural": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "Breadcrumb_data"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "sections",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "__typename",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "anchorName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "navigationTitle",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "titleImageUrl",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "titleImageBackgroundUrl",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "LinkSection_pageSection"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "OverviewSection_pageSection"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "HomeFundIntroductionSection_pageSection"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "HomeFundServiceSection_pageSection"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "HomeFundInfoserviceSection_pageSection"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "SectionPage",
  "abstractKey": null
};

(node as any).hash = "f350d81371223d49bdb2ef1b383d197e";

export default node;
